import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchProjectSelectlists,
  initialState,
} from '../services/fetchProjectSelectlists'

export { useProjectSelectlists }

const queryKey = 'selectlists-project'

const useProjectSelectlists = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchProjectSelectlists({ id }),
    queryKey: [queryKey, id],
    enabled: hasPermissions && !!id,
  })

  return {
    data: data || initialState.data,
  }
}
